import { useSelector, useDispatch } from 'react-redux'
import PresetsPopoverItem from './PresetsPopoverItem'
import { t } from '../../utils/i18n'
import Popover from '../Popover'
import { bikeConfigSetParams, angleSelected } from '../../actions'
import { getBaseModel } from '../../utils/bike-schema'
import { encode as encodeQueryParams } from '../../utils/query-params'
import { BACKEND_URL } from '../../utils/settings'

const PresetsPopover = () => {
  const dispatch = useDispatch()
  const bikeConfig = useSelector((state) => state.bikeConfig)
  const { baseModelId } = bikeConfig
  const baseModel = getBaseModel(baseModelId)
  const presets = baseModel.presets.map((preset) => {
    const params = {
      base_model_id: baseModelId,
      ...preset
    }
    return {
      params,
      imgUrl: `${BACKEND_URL}/bike-image?${encodeQueryParams(params)}&size=256x`
    }
  })
  const isCargo = baseModelId.includes('cargo')

  return (
    <Popover
      className="velorbis-customizer-gallery-popover"
      alignTo={
        window.innerWidth > 767
          ? '.velorbis-customizer-header-presets'
          : '.velorbis-customizer-header-settings'
      }
      position="below"
    >
      <div className="velorbis-customizer-popover-header">
        {t(isCargo ? 'select_angle' : 'presets_title')}
      </div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding velorbis-customizer-popover-body-scroll velorbis-customizer-presets-popover-inner">
        {presets.map(({ params, imgUrl }, idx) => {
          return (
            <PresetsPopoverItem
              key={idx}
              imgUrl={imgUrl}
              onClick={() =>
                dispatch(
                  isCargo
                    ? angleSelected(params.angle)
                    : bikeConfigSetParams(params)
                )
              }
            />
          )
        })}
      </div>
    </Popover>
  )
}

export default PresetsPopover
